<div class="container-pie-char">
  <mojo-pie-chart
    [inputTitleChar]="titleChar"
    [elements]="contentCenter.pieChartElements"
    [titleToCenter]="contentCenter.titleCenter"
    [numberToCenterChar]="contentCenter.total"
    [hiddenDataIn]="true"
  >
  </mojo-pie-chart>

  <div class="col">
    <div class="margin-top margin-bottom">
      {{!!showAverages? 'Averages per job' : 'Totals after offer'}}
    </div>
  </div>
  <div class="content ml-3">
    <div *ngFor="let item of pieCharAverage.data">
      <span
        class="color-indicator"
        [ngStyle]="{'background-color': item.color}"
      >
      </span>
      <span class="align-middle data-title-average">{{item.label}}</span>
    </div>
  </div>
  <div class="content">
    <div *ngFor="let item of pieCharAverage.data">
      <span
        class="align-middle data-title-average number-style">{{!!showAverages ? item.average : item.value}}</span>
      <span
        *ngIf="showAverages && item.percentage > 0"
        class="align-middle data-title-average data-percentage"
      >
        {{item.percentage}}%
      </span>
      <span
        *ngIf="!showAverages && item.totalPercentage > 0"
        class="align-middle data-title-average data-percentage"
      >
        {{item.totalPercentage}}%
      </span>
    </div>
  </div>
</div>
